export default "__VITE_ASSET__DLVQX0Yr__"